import { Component, OnInit } from '@angular/core';
import { CaseDetailedParticipantsComponent } from '@app/modules/case/pages/case-detailed-participants/case-detailed-participants.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { CaseService } from '@app/core/services/case.service';
import { ParticipantsService } from '@app/core/services/participants.service';
import { SelectComponentOptions } from '@app/shared/components/select/base-select-with-id.component';
import { Participant } from '@app/shared/models/participant';
import { ParticipantTypes } from '@app/shared/models/participant-type';
import * as _ from 'lodash-es';

@Component({
  templateUrl: './case-detailed-accident-opponent.component.html',
  styleUrls: ['./case-detailed-accident-opponent.component.scss']
})

export class CaseDetailedAccidentOpponentComponent extends CaseDetailedParticipantsComponent implements OnInit {
  
  public readonly accidentOpponentParticipants = [
    ParticipantTypes.ACCIDENT_OPPONENT_INSURANCE.key,
    ParticipantTypes.ACCIDENT_OPPONENT_POLICY_HOLDER.key,
    ParticipantTypes.ACCIDENT_OPPONENT_VEHICLE_OWNER.key,
    ParticipantTypes.ACCIDENT_OPPONENT_VEHICLE_DRIVER.key
  ];

  public generalTab: boolean;
  public vehicleTypeSelectOptions: SelectComponentOptions;
  public manufacturerSelectOptions: SelectComponentOptions;
  public excludedParticipantTypes: string[];

  constructor(protected componentServiceBundle: ComponentServiceBundle,
              protected caseService: CaseService,
              protected participantsService: ParticipantsService) {
    super(componentServiceBundle, caseService, participantsService);
    this._idPrefix = 'case_detailed_accident_opponent.';
  }

  public ngOnInit() {
    super.ngOnInit();
    this.generalTab = true;
    this.excludedParticipantTypes = ParticipantTypes.ALL_BUT(this.accidentOpponentParticipants).map(typeTrans => typeTrans.key);
  }

  protected whenOriginalFetched(): void {
    super.whenOriginalFetched();

    this.vehicleTypeSelectOptions = {
      label: 'vehicle.type',
      class: 'full-width',
      patchPath: 'accident.opponent.vehicle_type',
      uriParams: {
        urlSuffix: 'types'
      }
    };

    this.manufacturerSelectOptions = {
      label: 'vehicle.manufacturer',
      class: 'full-width',
      patchPath: 'accident.opponent.manufacturer',
      uriParams: {
        urlSuffix: 'manufacturers'
      }
    };
  }

  protected filterParticipants(): void {
    if (this.participants) {
      this.participants.items = _.filter(this.participants.items, (part) => {
        let isOfType = false;
        for (let i = 0; i < this.accidentOpponentParticipants.length; i++) {
          isOfType = part.isOfType(this.accidentOpponentParticipants[i]);

          if (isOfType) {
            break;
          }
        }
        return isOfType;
      });
    }
  }

  public openParticipant(participant: Participant) {
    super.openParticipant(participant);
    this.generalTab = !participant;
  }

}
